import { render } from "./PanelistAlternativePage.vue?vue&type=template&id=2caccc0c&ts=true"
import script from "./PanelistAlternativePage.vue?vue&type=script&lang=ts"
export * from "./PanelistAlternativePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__